export const getTokenPath = (path: string) => {
  return path.includes('color.') ? `color.${path}` : `theme.${path}`
}
